export default {
  methods: {
    sleep: function (time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    request: function (method, path, data) {
      return new Promise((resolve, reject) => {
        switch (method.toLowerCase()) {
          case 'get':
            window.axios.get(path)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'post':
            window.axios.post(path, data)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'put':
            window.axios.put(path, data)
              .then(async (response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
          case 'delete':
            window.axios.delete(path, data)
              .then((response) => {
                resolve(response);
              })
              .catch((e) => {
                reject(e)
              })
            break;
        }
      });
    },
    setEmptyPrice: function (price, kind) {
      if (kind !== '1') {
        let Teiki1Summary = price.find(p => p.kind === 'Teiki1Summary');
        if (Teiki1Summary) {
          Teiki1Summary.Oneway = '';
          for (let p of price) {
            if (p.kind === 'Teiki1') {
              p.Oneway = '';
            }
          }
        }
      }
      if (kind !== '3') {
        let Teiki3Summary = price.find(p => p.kind === 'Teiki3Summary');
        if (Teiki3Summary) {
          Teiki3Summary.Oneway = '';
          for (let p of price) {
            if (p.kind === 'Teiki3') {
              p.Oneway = '';
            }
          }
        }
      }
      if (kind !== '6') {
        let Teiki6Summary = price.find(p => p.kind === 'Teiki6Summary');
        if (Teiki6Summary) {
          Teiki6Summary.Oneway = '';
          for (let p of price) {
            if (p.kind === 'Teiki6') {
              p.Oneway = '';
            }
          }
        }
      }
    },
  },
}
